import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Col } from '../../../../../Shared/Grid'
import BookingWidget from '../../../../../Shared/BookingWidget'
import InputTracked from '../../../../../Shared/FormTracked/InputTracked'
import { trackingEvent } from '../../../../../../constants'

// Todo: feels like this is way to complicated written?
class Mapping extends Component {
  state = {
    hotelCode: '',
    chainCode: '',
    isValid: null
  }

  componentDidMount () {
    this.populateFromProps()
  }

  componentDidUpdate (prevProps) {
    if (prevProps !== this.props) {
      this.populateFromProps()
    }
  }

  populateFromProps () {
    let hotelCode = ''
    let chainCode = ''
    if (this.props.mappingValue) {
      hotelCode = this.props.mappingValue.hotelCode
      chainCode = this.props.mappingValue.chainCode
    }
    this.setState({ hotelCode, chainCode }, () => {
      this.validate()
    })
  }

  validate () {
    let isValid = true
    if (!this.validateFormValue('hotelCode', this.state.hotelCode, this.isRequired(this.state))) {
      isValid = false
    }
    if (!this.validateFormValue('chainCode', this.state.chainCode, this.isRequired(this.state))) {
      isValid = false
    }
    if (isValid !== this.state.isValid) {
      this.setState({ isValid }, () => {
        this.props.onValidationChange(isValid)
      })
    }
  }

  isRequired (state = null) {
    if (this.props.chainCodeRequired === false) {
      return false
    }
    if (state.chainCode === '' && state.hotelCode === '') {
      return false
    }
    return true
  }

  validateFormValue (key, value, isRequired) {
    if (isRequired && (value === null || value.toString().trim() === '')) {
      return false
    }
    return true
  }

  onChange = (e) => {
    const value = e.target.value
    let state = { ...this.state }
    state[e.target.name] = value
    if (!this.props.chainCodeRequired) {
      if (state.hotelCode === '') {
        this.props.onRemove(this.props.mapping.id)
        return
      }
    } else {
      if (state.chainCode === '' && state.hotelCode === '') {
        this.props.onRemove(this.props.mapping.id)
        return
      }
    }
    let newMapping = this.props.mappingValue ? { ...this.props.mappingValue } : {}
    newMapping.hotelCode = state.hotelCode
    newMapping.chainCode = state.chainCode
    newMapping.supplierId = this.props.mapping.id
    this.props.onChange(
      newMapping
    )
  }

  render () {
    const { t } = this.props
    const required = this.isRequired(this.state)
    const eventName = trackingEvent.editMappingInfoField
    return (
      <React.Fragment>
        {this.props.chainCodeRequired ?
          <React.Fragment>
            <Col xs={6}>
              <InputTracked
                eventName={eventName}
                eventOpts={{ field: this.props.mapping.name + ' ID' }}
                value={this.state.hotelCode} label={this.props.mapping.name + ' ID'}
                onChange={this.onChange}
                name={'hotelCode'}
                valid={this.validateFormValue('hotelCode', this.state.hotelCode, required)}
                required={required}/>
            </Col>
            <Col xs={6}>
              <InputTracked
                eventName={eventName}
                eventOpts={{ field: this.props.mapping.name + ' Chain Code' }}
                value={this.state.chainCode} label={t('CHAIN_CODE')}
                name={'chainCode'}
                onChange={this.onChange}
                valid={this.validateFormValue('chainCode', this.state.chainCode, required)}
                required={required}/>
            </Col>
          </React.Fragment>
          :
          <React.Fragment>
            <Col xs={this.props.mapping.id === 27 ? 6 : 12}>
              <InputTracked
                eventName={eventName}
                eventOpts={{ field: this.props.mapping.name + ' ID' }}
                value={this.state.hotelCode} label={this.props.mapping.name + ' ID'}
                name={'hotelCode'}
                onChange={this.onChange}
                valid={this.validateFormValue('hotelCode', this.state.hotelCode, required)}
                required={required}/>
            </Col>
            {this.props.mapping.id === 27 &&
              <Col xs={6}>
                <label>&nbsp;</label>
                <div><BookingWidget providerId={1628} providerName={'GIATA'}/></div>
              </Col>
            }
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

Mapping.propTypes = {
  mapping: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  mappingValue: PropTypes.shape(
    {
      supplierId: PropTypes.number.isRequired,
      hotelCode: PropTypes.string.isRequired,
      chainCode: PropTypes.string.isRequired
    }
  ),
  chainCodeRequired: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onValidationChange: PropTypes.func.isRequired
}
export default withTranslation()(Mapping)
